import HttpService from '@/common/services/HttpService'
import type { CasesMetadataDTOV1 } from '@/common/types/case'
import { type CreateCompanyDTO, type CompanyDetailsDTOV1, type CompanyFieldConfig, type ListCompanyActionDTOV1 } from '@/common/types/company'
import { EntityFieldCodeEnum } from '@/common/types/fields'
import { OperationEnum } from '@/search/types/search'
import { EntityEnum } from '@/common/types/general'

export const getBulkCompanies = async (ids?: number[], { expands }: CompanyFieldConfig = {}): Promise<CompanyDetailsDTOV1[]> => {
  const params = {
    expand: expands?.size ? [...expands].join() : undefined,
  }
  return HttpService.postData<CompanyDetailsDTOV1[]>('/api/v1/bulk-companies/fetch', { ids }, { params })
}

export const createCompany = async (data: CreateCompanyDTO): Promise<CompanyDetailsDTOV1> => {
  return HttpService.postData<CompanyDetailsDTOV1>('/api/v1/companies', data, {
    raw: true,
  })
}

export const getCompany = async (companyId: number, { expands }: CompanyFieldConfig = {}): Promise<CompanyDetailsDTOV1> => {
  const params = {
    expand: expands?.size ? [...expands].join() : undefined,
  }
  return HttpService.getData<CompanyDetailsDTOV1>(`/api/v1/companies/${companyId}`, {
    params,
  })
}

export const listCompanyActions = async (companyId: number): Promise<ListCompanyActionDTOV1[]> => {
  return HttpService.getData<ListCompanyActionDTOV1[]>(`/api/v1/companies/${companyId}/actions`)
}

export const getCompanyCasesMetadata = (companyId: number) => {
  return HttpService.getData<CasesMetadataDTOV1>(`/api/v1/companies/${companyId}/cases-metadata`)
}

export const getCompanyCases = async (companyId: number): Promise<number[]> => {
  return HttpService.postData<number[]>('/search/api/v1/specs', {
    entity: EntityEnum.TICKET,
    max: 1000,
    fields: [
      {
        code: EntityFieldCodeEnum.COMPANY_ID,
        op: OperationEnum.eq,
        values: [companyId.toString()],
      },
    ],
    criteria: [],
  })
}

export const getCompanyCustomers = async (companyId: number): Promise<number[]> => {
  return HttpService.postData<number[]>('/search/api/v1/specs', {
    entity: EntityEnum.CUSTOMER,
    max: 1000,
    fields: [
      {
        code: EntityFieldCodeEnum.COMPANY_ID,
        op: OperationEnum.eq,
        values: [companyId.toString()],
      },
    ],
    criteria: [],
  })
}

export const companyProperties: Record<string, keyof CompanyDetailsDTOV1> = {
  COMPANY_NAME: 'name',
  COMPANY_ADDRESS: 'address',
  COMPANY_ZIP_CODE: 'zipCode',
  COMPANY_CITY: 'city',
  COMPANY_COUNTRY: 'country',
  COMPANY_EXTERNAL_REF: 'externalRef',
  COMPANY_PHONE1: 'phone1',
  COMPANY_PHONE2: 'phone2',
  COMPANY_EMAIL1: 'email1',
  COMPANY_EMAIL2: 'email2',
}
